import { render, staticRenderFns } from "./ModalBankAccountTransferDetail.vue?vue&type=template&id=e48e8466"
import script from "./ModalBankAccountTransferDetail.vue?vue&type=script&lang=js"
export * from "./ModalBankAccountTransferDetail.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/bank-account-transfer-modals.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports